import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sas-station-register-resend',
  templateUrl: './sas-station-register-resend.component.html',
  styleUrls: [
    './sas-station-register-resend.component.css',
    '../style/global.css',
  ],
})
export class SasStationRegisterResendComponent implements OnInit {
  email: string = '';
  client_id: string;
  constructor(
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient
  ) {
    this.activatedRoute.queryParams.subscribe((query) => {
      this.client_id = query['client_id'];
    });
  }

  ngOnInit(): void { }

  get isSubmitable() {
    if (!this.email.length) return false;
    if (this.email) {
      const match = this.email.match(/^.*@.*\..+$/);
      return match;
    }
    return true;
  }

  async submit() {
    if (!this.isSubmitable) return;
    this.spinner.show();
    try {
      this.http
        .post(
          `https://${environment.domain}/management/api/v1/auth/verification-email`,
          {
            client_id: this.client_id,
            email: this.email,
          }
        )
        .subscribe((resp: { result: boolean }) => {
          this.spinner.hide();
          if (!resp.result) {
            return;
          }
          // メール送信ページへ飛ばす
          location.pathname = 'register-send';
        });
    } catch (error) {
      this.spinner.hide();
    }
  }
}
